import { useState, useEffect } from "react";

import {
  Box,
  Grid,
  Button,
  ButtonGroup,
  FormLabel,
  LinearProgress,
  Fade,
} from "@mui/material";
import Swal from "sweetalert2";
import {
  CommonSubHeader,
  useLocationHelpers,
} from "../../Components/helpers/Helpers";

// Context
import { useContext } from "react";
import { UserContext } from "../../Components/Context/Context";
import fondoBlanco from "../../assets/fondoblanco.jpg";
import { useSearchParams } from "react-router-dom";
import api from "../../api/axios";

const Ver = () => {
  const { goPanel, goEdit, goTable } = useLocationHelpers();
  const [searchParams] = useSearchParams();
  const officeId = searchParams.get("id");
  const [officeData, setOfficeData] = useState({
    officeEmail: "",
    officeName: "",
    officeProvince: null, // Cambiado a null para manejar Autocomplete
    officeAddress: "",
    officePostalCode: "",
    officeCif: "",
    officePhone: "",
    officeContactPerson: "",
  });

  const [flag, setFlag] = useState(false);
  const [companyData, setCompanyData] = useState({});

  // Obtener los datos del despacho
  const getDataOffices = async () => {
    setFlag(true);
    const url = `${process.env.REACT_APP_API_URL}/offices/show`;

    try {
      const response = await api.post(url, { office: officeId });
      console.log(response);

      const {
        office_email,
        office_name,
        office_province,
        office_address,
        office_postalcode,
        office_cif,
        office_phone,
        office_contactname,
        office_logo,
        company_relation,
      } = response.data.office;

      setCompanyData(company_relation || {});

      setOfficeData({
        officeEmail: office_email,
        officeName: office_name,
        officeProvince: office_province,
        officeAddress: office_address,
        officePostalCode: office_postalcode,
        officeCif: office_cif,
        officePhone: office_phone,
        officeContactPerson: office_contactname,
      });
    } catch (error) {
      console.error("Error fetching office data:", error); // Mensaje de error más descriptivo
    } finally {
      setFlag(false); // Asegurarse de desactivar la bandera en caso de error o éxito
    }
  };

  useEffect(() => {
    getDataOffices();
  }, [officeId]);

  const ImageCell = () => {
    // const { userData } = useContext(UserContext);
    // Verifica que `asocData.userCompany` y `asocData.userCompany.company_logo` existan antes de usarlos
    const imageUrl =
      companyData?.id && companyData?.company_logo // Verifica que existan `id` y `company_logo`
        ? `${process.env.REACT_APP_BACKEND_HOST}/storage/company/${companyData.id}/${companyData.company_logo}` // Usa la imagen original si está disponible
        : fondoBlanco; // Si no hay imagen, el valor será null

    return (
      <img
        src={imageUrl} // Usa una imagen de reemplazo si `imageUrl` es null
        alt="User logo"
        className="image-views"
      />
    );
  };

  const labels = {
    officeName: "Nombre de Despacho",
    officeEmail: "Correo",
    officeProvince: "Provincia",
    officeAddress: "Dirección",
    officePostalCode: "Código Postal",
    officeCif: "CIF",
    officePhone: "Teléfono",
    officeContactPerson: "Contacto",
  };

  return (
    <div className="fatherContainer">
      <CommonSubHeader title="Despachos" subTitle="Ver" />

      {flag && <LinearProgress color="info" />}
      <Fade in={!flag} timeout={800}>
        <div className="formMainContainer">
          {!flag && (
            <Grid
              container
              style={{ textAlign: "center" }}
              p={2}
              className="fontSize">
              <Grid item xs={12} md={4} className="image-view-container">
                {ImageCell()}
              </Grid>
              <Grid container item xs={12} md={8} textAlign={"left"}>
                {Object.entries(officeData).map(([key, value]) => (
                  <Grid item xs={12} textAlign={"left"} key={key}>
                    <FormLabel>
                      <b> {`${labels[key]}:`} </b> {`${value}`}{" "}
                    </FormLabel>
                  </Grid>
                ))}
              </Grid>
              <Grid item xs={12}>
                <ButtonGroup
                  sx={{
                    width: "100%",
                    justifyContent: "center",
                    textAlign: "center",
                    margin: "20px auto 0px auto",
                  }}>
                  <Button
                    sx={{ width: "100%" }}
                    onClick={() => goEdit("despachos", officeId, "Despacho")}
                    variant="outlined"
                    color="success">
                    Editar
                  </Button>
                  <Button
                    sx={{ width: "100%" }}
                    onClick={() => goTable("despachos", "Despachos")}
                    variant="outlined"
                    color="error">
                    Tabla
                  </Button>
                  <Button
                    sx={{ width: "100%" }}
                    onClick={goPanel}
                    variant="outlined">
                    Inicio
                  </Button>
                </ButtonGroup>
              </Grid>
            </Grid>
          )}
        </div>
      </Fade>
    </div>
  );
};

export default Ver;
